import PropTypes from "prop-types"
import React from "react"
import Image from "components/ui/Image"

function ImageWrapper({ image, width }) {
  return (
    image && (
      <div className="p-10 shadow-simple flex justify-center">
        <Image
          className="max-w-full shadow-simple mx-auto"
          src={image}
          style={width && { width }}
        />
      </div>
    )
  )
}

ImageWrapper.propTypes = {
  /** Image */
  image: PropTypes.oneOfType([PropTypes.string, PropTypes.shape({})]),
  /** Image Width */
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
}

export default ImageWrapper
